// extracted by mini-css-extract-plugin
export var button = "authFlowForm-module--button--08307";
export var returnLink = "authFlowForm-module--returnLink--7ba8e";
export var spinner = "authFlowForm-module--spinner--e6468";
export var trialLink = "authFlowForm-module--trialLink--37299";
export var wrapper = "authFlowForm-module--wrapper--a4f93";